module.exports = __webpack_public_path__ + "media/images/humidity-indicator-1-7515bc20936179cf95e40ee1d11afb66.svg";